import { inject, Injectable } from '@angular/core';
import { Message } from '../models/message.model';
import { MessagesService } from './messages.service';
import { NavigationService } from './navigation.service';
import { WorkerTicketsService } from './worker-tickets.service';

@Injectable({
  providedIn: 'root',
})
export class WorkerMessagesService {
  private messagesService = inject(MessagesService);
  private navigationService = inject(NavigationService);
  private workerTicketsService = inject(WorkerTicketsService);

  onReservation(siteGuid: string, reservation: string, message: Message) {
    this.navigationService.navigateToSite(siteGuid, { tabs: 'calendar', reservation });
    this.messagesService.markAsRead(message);
  }

  onTicket(ticket: string | null | undefined, roomTicket: string, message: Message) {
    this.workerTicketsService.openRoomTicket(ticket, roomTicket);
    this.messagesService.markAsRead(message);
  }
}
